import { formatDateTime, type DateTimeInput } from '@/utils/date'
import { useCallback } from 'react'
import { useAppLocale } from './useAppLocale'

export function useDateFormatter() {
  const locale = useAppLocale()

  const format = useCallback(
    (value: DateTimeInput, options?: Intl.DateTimeFormatOptions, fallback?: string) =>
      formatDateTime(value, locale, options, fallback),
    [locale],
  )

  return {
    locale,
    formatDateTime: format,
  }
}
